import { Card, CardHeader } from '@mui/material';
import { DateTimeFormats } from '@src/app/enums';
import { DateRange } from '@src/app/store';
import Colors from '@src/app/config/colorConfig';
import { dateFormatter, percentageFormatter } from '@src/app/utils/GenericUtils';
import { MultiPortfolioPerformanceDetails } from 'clientportalshared';

interface Props {
  dateRange: DateRange;
  data: MultiPortfolioPerformanceDetails;
}

export const TotalReturnCard = ({ dateRange, data }: Props): JSX.Element => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '13.85px',
        border: `1px solid ${Colors.gray300}`,
        boxShadow: '0px 1.84px 10.11px 1.84px #E4E4E4',
        minHeight: '100%',
      }}
    >
      <CardHeader
        title={`Total Return from ${dateFormatter(dateRange.dateFrom, false, DateTimeFormats.DateOnly)} to ${dateFormatter(
          dateRange.dateTo,
          false,
          DateTimeFormats.DateOnly
        )}`}
        subheader={percentageFormatter(data.totalReturnPercentage ?? 0, 2)}
        titleTypographyProps={{
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: 18,
        }}
        subheaderTypographyProps={{
          fontWeight: 700,
          fontSize: 20,
        }}
      />
    </Card>
  );
};
